// 系统管理
import request from "@/utils/request";

// 角色管理-列表
export const roleList = query => {
  return request({
    url: "/tax/PlatformRole/queryRoleList",
    method: "POST",
    data: query
  });
};

// 角色管理-状态切换
export const statusRole = query => {
  return request({
    url: "/tax/PlatformRole/switchStatus",
    method: "POST",
    data: query
  });
};

// 角色管理-新增
export const addRole = query => {
  return request({
    url: "/tax/PlatformRole/addRole",
    method: "POST",
    data: query
  });
};

// 角色管理-角色详情
export const roleDetail = query => {
  return request({
    url: "/tax/PlatformRole/details",
    method: "POST",
    data: query
  });
};

// 角色管理-新增-详情空树
export const rolesHollowTree = query => {
  return request({
    url: "/tax/PlatformMenu/getAllTreeMenu",
    method: "POST",
    data: query
  });
};

// 分配用户-列表
export const userList = query => {
  return request({
    url: "/tax/PlatformRole/allotUserList",
    method: "POST",
    data: query
  });
};

// 取消授权分配用户
export const cancelAssign = query => {
  return request({
    url: "/tax/PlatformRole/cancelImpower",
    method: "POST",
    data: query
  });
};

// 分配用户
export const assignUser = query => {
  return request({
    url: "/tax/PlatformRole/impowerUser",
    method: "POST",
    data: query
  });
};

// 部门管理-列表
export const departmentList = query => {
  return request({
    url: "/tax/PlatformDepartment/queryDepartmentList",
    method: "POST",
    data: query
  });
};

// 部门管理-前两级列表
export const departmentListTwo = query => {
  return request({
    url: "/tax/PlatformDepartment/querySupDepartment",
    method: "POST",
    data: query
  });
};

// 部门管理-状态切换
export const switchStatus = query => {
  return request({
    url: "/tax/PlatformDepartment/switchStatus",
    method: "POST",
    data: query
  });
};

// 部门管理-新增
export const departmentAdd = query => {
  return request({
    url: "/tax/PlatformDepartment/addDepartment",
    method: "POST",
    data: query
  });
};

// 部门管理-详情
export const departmentDetail = query => {
  return request({
    url: "/tax/PlatformDepartment/details",
    method: "POST",
    data: query
  });
};

// 部门管理-编辑
export const departmentEdit = query => {
  return request({
    url: "/tax/PlatformDepartment/editSave",
    method: "POST",
    data: query
  });
};

// 销售/运营列表
export const saleList = query => {
  return request({
    url: "/tax/PlatformUser/queryUserByRole",
    method: "POST",
    data: query
  });
};

// 用户管理-重置
export const resetPassword = query => {
  return request({
    url: "/tax/PlatformUser/resetPassword",
    method: "POST",
    data: query
  });
};

// 用户管理-详情
export const usersDetail = query => {
  return request({
    url: "/tax/PlatformUser/details",
    method: "POST",
    data: query
  });
};

// 用户管理-编辑
export const usersEdit = query => {
  return request({
    url: "/tax/PlatformUser/editUser",
    method: "POST",
    data: query
  });
};

// 用户管理-新增
export const usersAdd = query => {
  return request({
    url: "/tax/PlatformUser/addUser",
    method: "POST",
    data: query
  });
};

// 用户列表
export function usersList(data) {
  return request({
    url: "/tax/user/list",
    method: "post",
    data
  });
}

//   新增已存在用户
export function addExistedUser(data) {
  return request({
    url: "/tax/user/add/existed/user",
    method: "post",
    data
  });
}

//   新增新商户用户
export function addUser(data) {
  return request({
    url: "/tax/user/add/user",
    method: "post",
    data
  });
}

// 编辑
export function editUser(data) {
  return request({
    url: "/tax/user/edit",
    method: "post",
    data
  });
}

//  删除
export function deleteMerchantUser(id) {
  return request({
    url: `/tax/user/del/${id}`,
    method: "DELETE"
  });
}

//   停用/启用（取反）
export function usersStatus(id) {
  return request({
    url: `/tax/user/edit/status/${id}`,
    method: "GET"
  });
}

// 查询用户权限
export function merchantRole(id) {
  return request({
    url: `/tax/user/details/${id}`,
    method: "GET"
  });
}

//   用户菜单编辑
export function editRole(data) {
  return request({
    url: "/tax/user/edit/user/menu",
    method: "post",
    data
  });
}

// 平台脱敏配置列表
export const desensitizedList = query => {
  return request({
    url: "/tax/user/desensitized/list",
    method: "post",
    data: query
  });
};

// 查询账户脱敏设置
export const desensitizedConf = query => {
  return request({
    url: `/tax/user/desensitized/conf/${query}`,
    method: "get"
  });
};

// 设置账户脱敏设置
export const setDesensitizedConf = query => {
  return request({
    url: "/tax/user/desensitized/conf",
    method: "POST",
    data: query
  });
};

// 同步
export const getSystemSignway = query => {
  return request({
    url: "/tax/taxManage/get/system/sign/way",
    method: "get",
    params: query
  });
};

export const getOEM = () => {
  return request({
    url: "/tax/common/getAgentOemDetail",
    method: "POST"
  });
};

export const getSystemTimestamp = () => {
  return request({
    url: "/tax/common/system/timestamp",
    method: "get",
    skipSign: true
  });
};
